import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, doc, updateDoc, getDoc, setDoc, addDoc } from "firebase/firestore";
import { format } from "date-fns";

export default function FeedbackList() {
  const [feedback, setFeedback] = useState([]);
  const [categories, setCategories] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [newCategory, setNewCategory] = useState("");
  const [newSubcategory, setNewSubcategory] = useState("");
  const [customCategory, setCustomCategory] = useState("");

  useEffect(() => {
    const load = async () => {
      const fbSnap = await getDocs(collection(db, "feedback"));
      const fbItems = fbSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFeedback(fbItems.sort((a, b) => b.date?.toMillis?.() - a.date?.toMillis?.()));

      const metaSnap = await getDoc(doc(db, "metadata", "categories"));
      if (metaSnap.exists()) {
        const data = metaSnap.data();
        setCategories(data.categories || []);
      }
    };
    load();
  }, []);

  const uncertain = feedback.filter((entry) => entry.flaggedAsUncertain);
  const certain = feedback.filter((entry) => !entry.flaggedAsUncertain);

  const handleResolve = async (entry) => {
    const selectedCategory = newCategory || customCategory;
    const subcategory = newSubcategory || "";
    const full = subcategory ? `${selectedCategory} / ${subcategory}` : selectedCategory;

    await updateDoc(doc(db, "feedback", entry.id), {
      correctedCategory: full,
      flaggedAsUncertain: false,
    });

    await addDoc(collection(db, "logs"), {
      feedbackId: entry.id,
      action: "resolved",
      newCategory: full,
      timestamp: new Date(),
    });

    let updatedCategories = [...categories];
    let categoryExists = updatedCategories.find((c) => c.name === selectedCategory);

    if (!categoryExists && customCategory) {
      updatedCategories.push({ name: customCategory, subcategories: subcategory ? [subcategory] : [] });
    } else if (categoryExists && subcategory) {
      const subExists = categoryExists.subcategories.includes(subcategory);
      if (!subExists) {
        categoryExists.subcategories.push(subcategory);
      }
    }

    await setDoc(doc(db, "metadata", "categories"), {
      version: Date.now(),
      updatedAt: new Date(),
      categories: updatedCategories,
    });

    setCategories(updatedCategories);
    setExpanded(null);
    setNewCategory("");
    setCustomCategory("");
    setNewSubcategory("");
    setFeedback((prev) =>
      prev.map((e) =>
        e.id === entry.id ? { ...e, correctedCategory: full, flaggedAsUncertain: false } : e
      )
    );
  };

  const renderResolver = (entry) => (
    <div style={{ marginTop: 12, padding: 8, background: "#f0f0f0", borderRadius: 6 }}>
      <label>Välj kategori:</label>
      <select value={newCategory} onChange={(e) => setNewCategory(e.target.value)}>
        <option value="">-- Välj kategori --</option>
        {categories.map((cat) => (
          <option key={cat.name} value={cat.name}>{cat.name}</option>
        ))}
      </select>
      <br />
      <label>Eller ny kategori:</label>
      <input
        type="text"
        value={customCategory}
        onChange={(e) => setCustomCategory(e.target.value)}
        placeholder="Ny kategori"
      />
      <br />
      <label>Underkategori:</label>
      <input
        type="text"
        value={newSubcategory}
        onChange={(e) => setNewSubcategory(e.target.value)}
        placeholder="Valfri"
      />
      <br />
      <button onClick={() => handleResolve(entry)} style={{ marginTop: 8 }}>Spara</button>
    </div>
  );

  return (
    <div style={{ padding: 24 }}>
      <h2>Feedback ({feedback.length})</h2>

      {uncertain.length > 0 && (
        <>
          <h3>⚠️ Oklara poster</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {uncertain.map((entry) => (
              <li key={entry.id} style={{ padding: 12, marginBottom: 8, background: "#fff6f6", borderRadius: 8 }}>
                <strong>{entry.text}</strong>
                <div style={{ fontSize: 14, color: "#a00" }}>Oklar</div>
                <div style={{ fontSize: 12, color: "#999" }}>
                  {entry.date?.toDate?.() ? format(entry.date.toDate(), "yyyy-MM-dd HH:mm") : ""}
                </div>
                <button onClick={() => setExpanded(entry.id)} style={{ marginTop: 8 }}>Lös denna</button>
                {expanded === entry.id && renderResolver(entry)}
              </li>
            ))}
          </ul>
        </>
      )}

      {certain.length > 0 && (
        <>
          <h3>📝 Övrig feedback</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {certain.map((entry) => {
              const needsEdit = !entry.correctedCategory.includes("/");
              return (
                <li key={entry.id} style={{ padding: 12, marginBottom: 8, background: "#f5f5f5", borderRadius: 8 }}>
                  <strong>{entry.text}</strong>
                  <div style={{ fontSize: 14, color: "#555" }}>
                    Original: {entry.originalCategory} → {entry.correctedCategory}
                  </div>
                  <div style={{ fontSize: 12, color: "#999" }}>
                    {entry.date?.toDate?.() ? format(entry.date.toDate(), "yyyy-MM-dd HH:mm") : ""}
                  </div>
                  {needsEdit && (
                    <button onClick={() => setExpanded(entry.id)} style={{ marginTop: 8 }}>Lös denna</button>
                  )}
                  {expanded === entry.id && renderResolver(entry)}
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
}